<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<v-col cols="12">
								<v-combobox
									v-model="params.category"
									:items="categories"
									label="Категорія"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									:loading="loadings.category"
									:rules="[rules.required, rules.onlyFromList]"
									@change="onCategory"
									@focus="focusCategory"
								></v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.brand"
									:items="brands"
									label="Марка"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									:loading="loadings.brand"
									:rules="[rules.required, rules.onlyFromList]"
									@change="onBrand"
									@focus="focusBrand"
								></v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.model"
									:items="models"
									label="Модель"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									:loading="loadings.model"
									clearable
									@change="onModel"
									@focus="focusModel"
								></v-combobox>
								<!-- :rules="[rules.required]" -->
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.modelYear"
									:items="years"
									label="Рік випуску авто"
									outlined
									dense
									hide-details="auto"
									:loading="loadings.year"
									clearable
									@focus="focusYear"
								></v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.modelYearMin"
									:items="years"
									label="Рік випуску з"
									outlined
									dense
									hide-details="auto"
									:loading="loadings.year"
									clearable
									@focus="focusYear"
								></v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.modelYearMax"
									:items="years"
									label="Рік випуску по"
									outlined
									dense
									hide-details="auto"
									:loading="loadings.year"
									clearable
									@focus="focusYear"
								></v-combobox>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="params.type"
									:items="types"
									label="Категорія за об'ємом двигуна"
									item-text="code"
									item-value="id"
									outlined
									dense
									hide-details="auto"
									return-object
									clearable
									:loading="loadings.type"
								>
									<template v-slot:item="{ on, item }">
										<v-list-item v-on="on">
											<v-list-item-content>
												<v-list-item-title>{{ item.code }}</v-list-item-title>
												<v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-select>
							</v-col>
						</v-row>
					</v-form>

					<v-divider></v-divider>
					
					<v-list dense>
						<v-subheader>Файли</v-subheader>
						<v-list-item v-for="(file, i) in files" :key="i" :href="file.href" link>
							<v-list-item-icon>
								<v-menu offset-y open-on-hover v-if="visibleForAdmin">
									<template v-slot:activator="{ on, attrs }">
										<v-icon v-bind="attrs" v-on="on" v-text="file.icon" :color="file.color"></v-icon>
									</template>
									<v-list>
										<v-list-item @click="onDeletePriceCSV(file)">
											<v-list-item-icon>
												<v-icon>mdi-delete</v-icon>
											</v-list-item-icon>
											<v-list-item-title>Видалити</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
								<v-icon v-else v-text="file.icon" :color="file.color"></v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title v-text="file.title"></v-list-item-title>
								<v-list-item-subtitle>{{ file.mtime | formatDate}} {{ file.size }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<v-btn icon @click="onPriceSelected" :disabled="!selected.length">
					<v-icon>mdi-calculator</v-icon>
				</v-btn>
				<!-- <v-btn icon href="https://ortica-systems.com/api/medat/public/catalog/vehicle/Prices.csv" download="Prices123.csv">
					<v-icon>mdi-file-excel</v-icon>
				</v-btn> -->
				<z-generate-param  v-if="visibleForAdmin"></z-generate-param>
				<z-file tooltip="Створити каталог" @ok="createPriceCSV" v-if="visibleForAdmin"></z-file>

				<!-- PDF -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon large color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<div>
				<v-breadcrumbs
					:items="breadcrumbs"
					divider="-"
				></v-breadcrumbs>

				<!-- <v-breadcrumbs
					:items="items"
					divider="."
				></v-breadcrumbs> -->
			</div>
			<v-card flat>
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text>
					<!-- <z-form-average-price-ai :estimate="estimate" visible-adverts></z-form-average-price-ai> -->
					 <v-data-table
						v-model="selected"
						:items="items"
						:headers="headers"
						item-key="id"
						show-select
					>
						<template v-slot:item.model.name="{ item, value }">
							<span v-if="value">{{ value }}</span>
							<v-chip v-else color="red" label outlined dark>
								<v-icon left>mdi-exclamation</v-icon>
								{{ item.modelName }}
							</v-chip>
						</template>
						<template v-slot:item.actions="{ item, index }">
							<v-toolbar flat dense color="transparent">
								<!-- <v-btn icon @click="removePrice(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn> -->
								<z-detail v-model="item">
									<template v-slot:activator="props">
										<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-icon>mdi-pencil</v-icon>
										</v-btn>
									</template>
								</z-detail>

								<v-btn icon @click="onPrice(item)">
									<v-icon>mdi-calculator</v-icon>
								</v-btn>
							</v-toolbar>
						</template>
						<!-- <template v-slot:[`item.date`]="{ item }">
							<span>{{ item.date | formatDateTime }}</span>
						</template> -->
						<!-- <template v-slot:[`item.value`]="{ item }">
							<span v-if="item.currency.code=='UAH'">{{ item.value | toCurrencyUAH }}</span>
							<span v-else-if="item.currency.code=='USD'">{{ item.value | toCurrencyUSD }}</span>
							<span v-else>{{ item.value | toCurrency }}</span>
						</template> -->
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-container>

		<z-detail
			tooltip="create"
			:category="params.category"
			:brand="params.brand"
			:model="params.model"
			:modelYear="params.modelYear"
			:type="params.type"
		>
		<!-- @create="add" -->
			<template v-slot:activator="props">
				<v-fab-transition>
					<v-btn
						v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}"
						color="primary"
						dark
						fixed
						bottom
						right
						fab
						class="mb-8 mr-8"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-fab-transition>
			</template>
		</z-detail>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<!-- <z-pdf ref="pdf" :item="item"></z-pdf> -->
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
//import mixin from './mixin/parameters'
//import zRightSideControl from '@/views/components/drawer/RightSideControl'
import zDetail from '@/views/dialogs/details/CatalogVehicle'
import zFile from '@/views/dialogs/details/CatalogVehicleFile'
import zGenerateParam from '@/views/dialogs/details/CatalogVehicleGenerateParam'
import zPdf from '@/views/pdf/VehicleAveragePriceAI'
import downloadExcel from "vue-json-excel";

export default {
	name: 'CatalogVehicle',
	//mixins: [mixin],
	components: {
		zDetail, zFile, zGenerateParam,
		zPdf,
		downloadExcel
	},
	data: () => ({
		title: 'Каталог цін транспортних засобів',
		subtitle: "Ціна транспортних засобів, визначена за допомогою технології AI, за критеріями: марка, модель, рік виробництва, категорія ТЗ за об'ємом двигуна",
		loading: false,

		headers: [
			//{ text: 'Id', value: 'id',  sortable: true },
			//{ text: 'code', value: 'code',  sortable: true },
			//{ text: 'name', value: 'name',  sortable: true },
			//{ text: 'Категорія', value: 'category.name', sortable: true },
			{ text: 'Марка', value: 'brand.name', sortable: true },
			{ text: 'Модель', value: 'model.name', sortable: true },
			//{ text: 'Модель', value: 'modelName', sortable: true },
			{ text: 'Рік', value: 'modelYear', sortable: true },
			//{ text: 'Тип кузова', value: 'bodystyle.name', sortable: true },
			{ text: 'Тип палива', value: 'fuel.name', sortable: true },
			//{ text: 'Колір', value: 'color.name', sortable: true },
			{ text: 'Тип', value: 'type.code', sortable: true },
			{ text: 'К-ть цін', value: 'prices.length', sortable: true },
			{ text: 'Рейтинг', value: 'rating', sortable: true },
			{ text: 'Опис', value: 'description', sortable: true },
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		selected: [],

		loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
			type: false,
		},

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
		},

		files: [],

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},

		breadcrumbs: [
			{
				text: 'Home',
				disabled: false,
				to: { name: 'home'}
			},
			{
				text: 'Звіти',
				disabled: false,
				to: { name: 'Report'}
			},
		],
	}),

	computed: {
		...mapGetters(['roles']),
		...mapGetters('CatalogVehicle', [ 'params', 'items' ]),
		...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),
		...mapGetters('VehicleInsuranceType', { insuranceTypes: 'items' }),

		types() {
			//console.log(this.$options.name, 'insuranceTypes', this.insuranceTypes)
			//console.log(this.$options.name, 'Filtered', this.insuranceTypes.filter((element) => ['B1','В2','B3','B4'].includes(element.code)))

			return this.insuranceTypes.filter((element) => ['B1','B2','B3','B4'].includes(element.code))
		},
		/* ...mapGetters('VehicleEstimate', [
			'params', 'item', 'isset'
		]), */

		/* excelName() {
			return this.title + (this.params.number ? ' ' + this.params.number : (this.params.vin ? ' ' + this.params.vin : '') + '.' +  this.excel.type)
		},

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		}, */

		visibleForAdmin() {
			//console.log(this.$options.name, 'visibleDeleteModel', 'holder', this.holder)
			//return this.holder?.roles ? this.holder.roles.includes('ADMIN') : false
			return this.roles.includes('ADMIN')
		},
	},

	created () {
		//console.log(this.$options.name, 'created')
		this.loadPriceCSV();
		this.focusCategory()?.then(() => this.$set(this.params, 'category', this.categories[0]))
	},

	methods: {
		...mapActions('CatalogVehicle', [ 'search' ]),
		...mapActions('VehicleCategory', { loadCategory: 'load'}),
		...mapActions('VehicleBrand', { loadBrand: 'load', setBrands: 'setItems' }),
		...mapActions('VehicleBrandModel', { loadModel: 'load', setModels: 'setItems' }),
		...mapActions('VehicleBrandModelYear', { loadYear: 'load', setYears: 'setItems' }),
		...mapActions('VehicleInsuranceType', { loadType: 'load' }),

		onClear() {
			this.$refs.form.reset()
			//this.clear()
		},

		clearBrand () {
			this.$set(this.params, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.params, 'model', null)
			this.setModels()
		},

		clearYear () {
			this.$set(this.params, 'yearProd', null)
			this.setYears()
		},

		onCategory (item) {
			this.clearBrand()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearYear()
		},
		onType (item) {
			//this.clearYear()
		},

		focusCategory(e) {
			if(this.categories.length == 0) {
				this.loadings.category = true
				return this.loadCategory(this.params).finally(() => (this.loadings.category = false));
			}
		},

		focusBrand() {
			if(this.params?.category?.id && this.brands.length == 0) {
				this.loadings.brand = true
				return this.loadBrand(this.params).finally(() => (this.loadings.brand = false));
			}
		},

		focusModel() {
			if(this.params?.category?.id && this.params?.brand?.id && this.models.length == 0) {
				this.loadings.model = true
				return this.loadModel(this.params).finally(() => (this.loadings.model = false));
			}
		},

		focusYear() {
			if(this.params?.model?.id) {
				this.loadings.year = true
				return this.loadYear(this.params).finally(() => (this.loadings.year = false));
			}
		},

		focusType() {
			this.loadings.type = true
			return this.loadType(this.params).finally(() => (this.loadings.type = false));
		},

		/* validate() {
			//return true
			return this.params.number 
				|| this.params.vin
				|| this.params.brand
				|| this.params.model
		}, */

		onOK() {
			if(this.$refs.form.validate()) {

				let params = {}
				if(this.params.category) 		params['category'] = this.params.category.id;
				if(this.params.brand) 			params['brand'] = this.params.brand.id;
				if(this.params.model) 			params['model'] = this.params.model.id;
				if(this.params.modelYear) 		params['year'] = this.params.modelYear;
				if(this.params.modelYearMin) 	params['yearMin'] = this.params.modelYearMin;
				if(this.params.modelYearMax) 	params['yearMax'] = this.params.modelYearMax;
				if(this.params.type) 			params['type'] = this.params.type.id;

				//console.log(this.$options.name, 'params', params)

				if (Object.keys(params).length > 0) {
					this.loading = true
					this.search(params).finally(() => {
						this.loading = false
					});
				}
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},

		// Визначення ціни транспортного засобу
		price(item) {
			let that = this
			return axios.post(`/catalog/vehicle/${item.id}/price`).then(response => {
				//console.log(this.$options.name, 'price','response.data', response.data)
				
				const index = that.items.indexOf(item)
                that.items.splice(index, 1, response.data)
			}, error => {
				console.log(error)
			})
		},

		onPrice(item) {
			this.loading = true
			this.price(item).finally(() => (this.loading = false));
		},

		// Визначення ціни виділених транспортних засобів
		onPriceSelected() {
			//console.log(this.$options.name, 'priceSelected','selected', this.selected)

			var promices = []

			this.selected.forEach((item) => promices.push(this.price(item)))

			this.loading = true
			Promise.all(promices).then((values) => {
				//console.log(values);
			}).finally(() => (this.loading = false));
		},

		loadPriceCSV() {
			let that = this
			return axios.get(`/catalog/vehicle/price/csv`).then(response => {
				//console.log(that.$options.name, 'loadPriceCSV','response.data', response.data)
				let data = response.data
				data.sort((a, b) => new Date(b.mtime) - new Date(a.mtime));
				that.files = data
			}, error => {
				console.log(error)
			})
		},

		createPriceCSV(item) {
			//console.log(this.$options.name, 'onPriceCSV','item', item)
			//this.files.unshift(item)
			this.loadPriceCSV()
		},

		onDeletePriceCSV(item) {
			//console.log(this.$options.name, 'onDeletePriceCSV','item', item)
			let that = this
			return axios.delete(`/catalog/vehicle/price/csv/${item.name}`).then(response => {
				//console.log(that.$options.name, 'loadPriceCSV','response.data', response.data)
				const index = that.files.indexOf(item)
				that.files.splice(index, 1);
			}, error => {
				console.log(error)
			})
		},
	},
}
</script>